import '@shoelace-style/shoelace/dist/translations/de.js';
import SlDetails from '@shoelace-style/shoelace/dist/components/details/details.js';
import SlIcon from '@shoelace-style/shoelace/dist/components/icon/icon.js';
import SlButton from '@shoelace-style/shoelace/dist/components/button/button.js';
import SlDrawer from '@shoelace-style/shoelace/dist/components/drawer/drawer.js';
import SlIconButton from '@shoelace-style/shoelace/dist/components/icon-button/icon-button.js';
import SlProgressBar from '@shoelace-style/shoelace/dist/components/progress-bar/progress-bar.js';
import SlRadioButton from '@shoelace-style/shoelace/dist/components/radio-button/radio-button.js';
import SlRadioGroup from '@shoelace-style/shoelace/dist/components/radio-group/radio-group.js';
import SlRange from '@shoelace-style/shoelace/dist/components/range/range.js';
import SlSelect from '@shoelace-style/shoelace/dist/components/select/select.js';
import SlSpinner from '@shoelace-style/shoelace/dist/components/spinner/spinner.js';
import SlDialog from '@shoelace-style/shoelace/dist/components/dialog/dialog.js';
import SlBadge from '@shoelace-style/shoelace/dist/components/badge/badge.js';
import SlTab from '@shoelace-style/shoelace/dist/components/tab/tab.js';
import SlTabGroup from '@shoelace-style/shoelace/dist/components/tab-group/tab-group.js';
import SlTabPanel from '@shoelace-style/shoelace/dist/components/tab-panel/tab-panel.js';
import SlInput from '@shoelace-style/shoelace/dist/components/input/input.js';
import SlOption from '@shoelace-style/shoelace/dist/components/option/option.js';
import {CaConfigureElement} from './elements/CaConfigureElement';
import {CaCollapseElement} from './elements/CaCollapseElement';
import {CaListElement} from './elements/CaListElement';
import {CaListMapElement} from './elements/CaListMapElement';
import {MultiInputElement} from './elements/MultiInputElement';
import {CaDetailElement} from './elements/CaDetailElement';
import {CaFormElement} from './elements/CaFormElement';
import {CaSearchElement} from './elements/CaSearchElement';

// prevent tree-shaking
export {
  CaConfigureElement,
  CaCollapseElement,
  CaListElement,
  CaListMapElement,
  MultiInputElement,
  CaSearchElement,
  CaDetailElement,
  CaFormElement,
  SlBadge,
  SlDetails,
  SlIcon,
  SlButton,
  SlDialog,
  SlDrawer,
  SlIconButton,
  SlInput,
  SlProgressBar,
  SlRadioButton,
  SlRadioGroup,
  SlRange,
  SlSelect,
  SlOption,
  SlSpinner,
  SlTab,
  SlTabPanel,
  SlTabGroup,
};

class Suche4 {
  constructor() {
    // WRS-Theme Dark mode workaround
    const darkModeEl = document.querySelector('.wrs-toggle-theme');
    darkModeEl?.addEventListener(
      'click',
      () => location.reload(),
    );

    /**
     * Smartmaps-workaround:
     * Add importmap for bare specifier import "screenfull"
     */
    const importMap = {
      imports: {
        screenfull: import.meta.resolve('./screenfull.js'),
      },
    };
    const im = document.createElement('script');
    im.type = 'importmap';
    im.textContent = JSON.stringify(importMap);
    document.head.append(im);
  }
}

new Suche4();
